/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_double_range.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value to a `double_range` value.
 * Strings are parsed as a double range in the format `start..end`, where `start` and `end` are double-precision floating-point numbers. The range is half-open `[start, end)`.
 *
 * @example
 * ROW str = "1.5..2.5"
 * | EVAL range = TO_DOUBLE_RANGE(str)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_double_range',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'double_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double_range',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double_range',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double_range',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
